import { useParams, useSearchParams } from "react-router-dom";
import Pagination from "@/components/Pagination";
import { useMaterials } from "../hooks/useMaterials";
import MaterialCard from "./MatirialCard";

function Materials() {
    const [searchParams, setSearchParams] = useSearchParams();

    const page = searchParams.get("materialsPage")
        ? parseInt(searchParams.get("materialsPage"), 10) < 1
            ? 1
            : parseInt(searchParams.get("materialsPage"), 10)
        : 1;

    const { courseId, lectureId } = useParams();
    const { materials, isPending } = useMaterials({
        courseId,
        lectureId,
        page,
        perPage: 6,
    });

    const totalPages = Math.ceil(
        materials?.meta?.total / materials?.meta?.per_page
    );

    return (
        <div>
            <div className="flex items-center justify-start gap-3 pt-6 border-t-2">
                <p className="text-2xl font-bold text-blue-color-primary">
                    الملفات
                </p>
            </div>
            {!isPending && (
                <div className="w-full py-10">
                    {materials?.data?.length ? (
                        <ul className="flex flex-wrap gap-5">
                            {materials?.data?.map((item) => {
                                return (
                                    <MaterialCard
                                        key={item.id}
                                        material={item}
                                    />
                                );
                            })}
                        </ul>
                    ) : (
                        <p className="mt-10 text-lg font-semibold text-center text-gray-color-primary">
                            لا يوجد ملفات مرفقة لهذه المحاضره
                        </p>
                    )}
                    <div className="flex justify-center w-full">
                        {totalPages > 1 && !isPending ? (
                            <Pagination
                                setSearchParams={setSearchParams}
                                page={page}
                                total={totalPages}
                                className="mt-5"
                                paginationKey="materialsPage"
                            />
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Materials;
